import type { RichText } from '@eneco/cms-sanity';

/**
 * Domain view of the `RichText` block, based on the **generated** `RichText` type
 * (`@eneco/cms-sanity`).
 *
 * G2: the generated type is **field-less** (`{ _type, componentName }`) — the migrator never mapped
 * Sitecore's `content` Rich Text field into the CMS schema, so a *migrated* RichText block carries no body
 * at all and no component code can rescue it; that fix belongs in `@migrator/transform`.
 *
 * What the component can do is not depend on one field name: Sitecore's unwrapped field is `content`,
 * the POC schema uses `body`, and a future build may use either. Hence the candidate list —
 * every member is `unknown` and goes straight to `adapter.toRichText`, which accepts an HTML string
 * (Sitecore) or a Portable Text array (Sanity). Do NOT hand-model the body shape here; let the
 * generated type carry it once G2 is fixed.
 */
export type RichTextContent = RichText & {
  content?: unknown;
  body?: unknown;
  text?: unknown;
  richText?: unknown;
};

/** Body field names to try, in order. `content` first: that is Sitecore's field and the name a fixed build would use. */
export const RICH_TEXT_BODY_FIELDS = ['content', 'body', 'text', 'richText'] as const;
